export interface ConferenceDay {
    id: string;
    title: string;
    dateTitle: string;
    summary?: string;
    slots: TimeSlot[];
    highlight?: string;
    startTime?: number;
}

export interface TimeSlot {
    duration?: number;
    talkSlug?: string|null;
    workshopSlug?: string|null;
    title?: string;
    description?: string;
    description2?: string;
    url?: string;
    timeTitle?: string;
}


const rawSchedule: ConferenceDay[] = [
    {
        id: 'day1',
        title: 'Conference - Day 1',
        dateTitle: 'Wednesday - June 26',
        highlight: 'Included in all tickets',
        startTime: 510,
        slots: [
                { title: '✏️ Registration, coffee & pastries', duration: 45 },
                { title: '🎤 Opening', duration: 30 },
                { talkSlug: 'run-design-sprints-and-become-a-product-hero', duration: 45 },
                { talkSlug: 'building-and-scaling-a-culture-of-ab-testing', duration: 45 },
                { talkSlug: 'the-npu-revolution', duration: 40 },
                { title: '🍽🍷 Lunch', duration: 110 },
                { talkSlug: 'building-great-offline-first-apps', duration: 45 },
                { talkSlug: 'design-system-and-component-libraries-at-spotify', duration: 45 },
                { talkSlug: 'how-we-built-a-design-system', duration: 45 },
                { title: '☕️ Coffee break', duration: 40 },
                // { talkSlug: 'designing-for-love-how-to-humanize-dating-apps', duration: 45 },
                { talkSlug: 'good-rules-for-bad-apps', duration: 45 },


                { talkSlug: 'think-and-solve-for-user-expectations', duration: 40 },

                { title: '👏 Conference day ends', duration: 0 },
        ],
    },
    {
        id: 'workshops',
        title: 'Workshops - Day 2',
        dateTitle: 'Thursday - June 27',
        highlight: 'Workshop ticket required',
        startTime: 540,
        slots: [
            { workshopSlug: 'design-research-beyond-user-testing', duration: 0 },
            { workshopSlug: 'seeing-map-and-flatmap-as-swift-design-patterns', duration: 300 },
            { workshopSlug: 'building-design-systems-with-googles-material-design', duration: 0 },
            { workshopSlug: 'towards-good-coverage-in-android', duration: 300 },
        ],
    },
    {
        id: 'activities',
        title: 'Activities - Day 2',
        dateTitle: 'Thursday - June 27',
        highlight: 'Included in all tickets',
        summary: 'Exact times vary and are listed on the reservation page (we\'ve sent the link to your email).',
        slots: [
            { title: 'Mini Spanish Cooking Experience', description2: 'Duration: 1.5 hours', url: '/activities' },
            { title: 'Barcelona Walking Tour', description2: 'Duration: 2 hours', url: '/activities' },
            { title: 'Barcelona Street Art Walking Tour', description2: 'Duration: 1.5 hours', url: '/activities' },
            { title: 'Port and Barcelona Skyline Boat Tour', description2: 'Duration: 1 hour', url: '/activities' },
            { title: 'Adrenalin Power Boat Experience - great views too!', description2: 'Duration: 1 hour', url: '/activities' },
            { title: 'Beach Party and Games Day', description2: 'Duration: 2 hours', url: '/activities' },
        ],
    },
    {
        id: 'party',
        title: 'Party - Day 2',
        dateTitle: 'Thursday - June 27',
        highlight: 'Included in all tickets',
        startTime: 1140,
        slots: [
            { title: '🎉 ADDC party doors open', url: '/party', duration: 60 },
            { title: '🍽 BBQ dinner served', duration: 4 * 60 },
            { title: '👋 Party ends', duration: 0 },
        ],
    },
    {
        id: 'day3',
        title: 'Conference - Day 3',
        dateTitle: 'Friday - June 28',
        highlight: 'Included in all tickets',
        startTime: 540,
        slots: [
            { title: '☕️ Breakfast (Coffee & pastries)', duration: 40},
            { talkSlug: 'thrive-with-ux', duration: 45 },
            { talkSlug: 'everyone-does-research', duration: 45 },
            { title: '☕️ Short coffee break', duration: 20},
            { talkSlug: 'first-steps-in-visualizing-functional-programming', duration: 40 },
            { title: '🍽🍷 Lunch', duration: 110 },
            { talkSlug: 'how-to-make-your-professional-dreams-come-true', duration: 40 },
            { talkSlug: 'fearless-and-forward', duration: 40 },
            { title: '☕️ Coffee break', duration: 40 },
            { talkSlug: 'consistency-is-key', duration: 45 },
            { talkSlug: 'designing-for-interface-next', duration: 40 },

            { title: '👏 Closing & conference day ends', duration: 0 },
        ],
    },
];

function twoDigits(val: number) {
    return (('0' + val).slice(-2));
}

function timeStringFromTimestamp(timestamp: number): string {
    const hours = Math.floor(timestamp / 60);
    const minutes = (timestamp % 60);
    return `${twoDigits(hours)}:${twoDigits(minutes)}`;
}

const schedule = rawSchedule.map((line: ConferenceDay) => {
    if (!line.startTime) {
        return line;
    }

    const mappedLine = line;
    let currentTime = line.startTime;
    mappedLine.slots = line.slots.map((slot: TimeSlot) => {
        const mappedSlot = slot;
        mappedSlot.timeTitle = timeStringFromTimestamp(currentTime);
        currentTime += mappedSlot.duration || 0;
        return slot;
    });
    return mappedLine;
});

export const getScheduleWithDay: (dayID: string) => ConferenceDay[] = (filterDayID) => {
    return schedule.filter((day: ConferenceDay) => day.id === filterDayID);
};

export default schedule;
